'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var RecurringEvent = function RecurringEvent(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({
    width: "24",
    height: "24",
    viewBox: "0 0 20.9 22.2"
  }, props), React__default["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13,11.8l-1.7,1.8h1.3c0,1.4-1.1,2.6-2.5,2.6c-0.4,0-0.8-0.1-1.2-0.3l-0.6,0.6\n            c0.5,0.3,1.1,0.5,1.8,0.5c1.9,0,3.4-1.6,3.4-3.5h1.3L13,11.8z M7.5,13.6c0-1.4,1.1-2.6,2.5-2.6c0.4,0,0.8,0.1,1.2,0.3l0.6-0.6\n            c-0.5-0.3-1.1-0.5-1.8-0.5c-1.9,0-3.4,1.6-3.4,3.5H5.4l1.7,1.8l1.7-1.8H7.5z M17.4,3.1h-1v-2h-2v2h-8v-2h-2v2h-1c-1.1,0-2,0.9-2,2\n            l0,14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-14C19.4,4,18.5,3.1,17.4,3.1z M17.4,19.1h-14v-11h14V19.1z"
  }));
};

var RecurringEvent$1 = iconStyles()(RecurringEvent);

module.exports = RecurringEvent$1;
